//////// GHG 3.12 EF
const threeTwelveSchema = {
  title: "3.12 End-of-Life Treatment of Solid Products",
  cat: "5_3",
  catName: "cat5",
  progressiveOrderSwitch: {
    by: { level: 2, key: "sourceEFName5_3" },
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    //////// Data Source
    {
      key: "emissionFactorTypeId",
      level: 1,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    //////// Emission Factor Database Source
    {
      key: "sourceEFName5_3",
      level: 2,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "5_3",
      },
      showIf: {
        all: [
          { level: 1, key: "emissionFactorTypeId", ne: "2" },
          { level: 1, key: "emissionFactorTypeId", notEmpty: true },
        ],
      },
      combineKey: 1,
    },
    //////// Waste Treatment Method
    {
      key: "wasteTreatmentMethod5_3",
      level: 3,
      type: "select",
      label: "Waste Treatment Method",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 2,
        key: "sourceEFName5_3",
      },
      showIf: {
        all: [{ level: 2, key: "sourceEFName5_3", notEmpty: true }],
      },
      combineKey: 2,
    },
    //////// Waste Type / Name
    {
      key: "emissionFactorId",
      level: 4,
      type: "select",
      label: "Waste Type / Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 3,
        key: "wasteTreatmentMethod5_3",
      },
      showIf: {
        all: [{ level: 3, key: "wasteTreatmentMethod5_3", notEmpty: true }],
      },
      combineKey: 3,
    },
    //////// 自定義
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 4,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat5CustomEFDropdownList",
      showIf: {
        level: 1,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};
export default threeTwelveSchema;
